<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnPrintVisible="false">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="toolbar">
            <!-- <print-component :documentRepository="true" :idRisorsa="idAccettazione"></print-component> -->
            <!-- <b-button size="sm" variant="btn--md btn-light waves-effect waves-light btn-toolbar  float-sm-right" @click="loadStampeReport" :hidden="isBtnStampa">
				<b-icon icon="printer"></b-icon>
				Stampa
			</b-button> -->
        </template>
        <template slot="table-body">
            <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
                <b-tab title="Storico Posti Letto" id="tbStoricoPostiLetto" active>
                    <rsa-paziente-stato-ricoveri-letto-list-component ref="cmpRsaPazienteStatoRicoveriLettoList"></rsa-paziente-stato-ricoveri-letto-list-component>
                </b-tab>
            </b-tabs>
            <print-component v-show="false" ref="cmpPrint"></print-component>
            <modal-error ref="cmpModalError"></modal-error>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteStatoRicoveriLettoListComponent from "../components/RsaPazienteStatoRicoveriLettoListComponent.vue";
//import RsaSchedaOspiteDimissioneTrasferimentoComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteDimissioneTrasferimentoComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        ModalError,
        SaPageLayout,
        PrintComponent,
        RsaOspiteAnagraficaComponent,
        RsaPazienteStatoRicoveriLettoListComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/rsaaccettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            linkPrintData: "",
            listKey: 0,
            activeTabIndex: 0,
            isPageGestioneOspite: true,
            isBtnStampa: false,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.linkPrintData = "/rsaaccettazioni/printdata/" + me.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaPazienteStatoRicoveriLettoList.init(me.jsonData);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];

            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            me.isBtnStampa = true;
            switch (idActiveTab) {
                case "tbStoricoPostiLetto":
                    me.$refs.cmpRsaPazienteStatoRicoveriLettoList.init(me.jsonData);
                    break;
            }
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
